
import { Component, EventEmitter, OnDestroy, OnInit, Output, ViewChild } from '@angular/core';
import { UntypedFormGroup, UntypedFormBuilder, UntypedFormControl, Validators } from '@angular/forms';
import { Subscription } from 'rxjs';

import { NgbModal } from '@ng-bootstrap/ng-bootstrap';

import { FormBase } from '@shared/form-base.component';

import { SharedService } from '@services/shared.service';
import { SessionManager } from '@services/session-manager';
import { ApiAuthService } from '@services/api-auth.service';

import { LoginModel } from '@models/LoginModel';
import { SessionModel } from '@models/SessionModel';
import { CustomerModel } from '@models/CustomerModel';


@Component({
    selector: 'app-login-modal',
    templateUrl: './login-modal.component.html',
    styleUrls: ['./login-modal.component.scss']
})
export class LoginModalComponent extends FormBase<LoginModel> implements OnInit, OnDestroy {

    @Output() onLoginSuccess: EventEmitter<CustomerModel> = new EventEmitter<CustomerModel>();

    @ViewChild('showModalLogin', { static: true }) modal: any;

    // form
    loginForm: UntypedFormGroup;

    loginModel: LoginModel;

    errorMsg = '';

    showLoginModalSubscription: Subscription = null;

    constructor(private formBuilder: UntypedFormBuilder, private modalService: NgbModal, public sharedService: SharedService, private apiAuthService: ApiAuthService) {
        super();
    }

    ngOnInit(): void {

        this.showLoginModalSubscription = this.sharedService.showLoginModal.subscribe(show => {
            if (show) this.openModal();
        });

        this._formInit();
    }

    openModal() {

        this.modalService.open(this.modal, {
            backdrop: 'static', keyboard: false,
            size: 'sm', centered: true, windowClass: 'modal-full'
        });
    }

    ngOnDestroy() {

        if (this.showLoginModalSubscription) { this.showLoginModalSubscription.unsubscribe(); }
    }

    onLoginSubmit(): void {

        // if is invalid, show the form errors
        if (this.loginForm.invalid) {

            this.touched = false;
            return;
        }

        this.loginModel = new LoginModel({
            username: this.username?.value?.trim(),
            password: this.password?.value?.trim(),
            remember: false
        });


        this.errorMsg = null;
        this.sharedService.setLoading(true);

        this.apiAuthService.login(this.loginModel.username, this.loginModel.password, this.loginModel.remember).then(
            (session: SessionModel) => {

                this.sharedService.setLoading(false); // hide loader

                const loggedIn = (session.accessToken != null);
                if (loggedIn) {

                    this.onLoginSuccess.next(session.user);
                    this.closeModal();
                } else {

                    // display error
                    this.errorMsg = 'Nombre de usuario o contraseña es inválida';
                }
            },
            (err: any) => {
                this.sharedService.setLoading(false); // hide loader
                // display error
                this.errorMsg = this.apiAuthService.getErrorMsg(err, 'Nombre de usuario o contraseña es inválida');
            }
        );
    }

    // Form

    get username() { return this._formGet(this.loginForm, 'username'); }
    get invalidUsername(): boolean {
        if (this.username && this.username.value) {
            this.username.setValue(this.username.value.trim());
        }
        return this._isInvalid(this.loginForm, 'username', this.touched);
    }

    get password() { return this._formGet(this.loginForm, 'password'); }
    get invalidPassword(): boolean {
        return this._isInvalid(this.loginForm, 'password', true) && !this._isInvalid(this.loginForm, 'username');
    }

    get remember() { return this._formGet(this.loginForm, 'remember'); }

    private _formInit(): void {

        // Reset for hide form errors
        this.touched = true;

        // load stored credentials.
        this.loginModel = SessionManager.getCredentials() || new LoginModel();

        this.loginForm = this.formBuilder.group({
            username: new UntypedFormControl(
                this.loginModel.username,
                [Validators.required, Validators.email]
            ),
            password: new UntypedFormControl(
                this.loginModel.password,
                [Validators.required]
            ),
            remember: new UntypedFormControl(
                this.loginModel.remember
            )
        });
    }

    // End Form

    closeModal() {

        this.modalService.dismissAll();
        this.sharedService.setShowLoginModal(false);
    }
}
